import TMSGetQuoteScreen from '../../screens/Shipment/TMSGetQuoteScreen';

const GetQuotePage = () => {
  return (
    <div className="h-100 pb-15">
      <TMSGetQuoteScreen />
    </div>
  );
};

export default GetQuotePage;
